import * as React from 'react'
import {
    Table,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    TableVariant
} from '@patternfly/react-table';
import {
    ResourceItem,
    ResourceItemVariants,
    ResourceItemType
} from '@app/components/ResourceItem'

import { SecretFile } from '@app/SecretManager/SecretsExplorer/model/repository'
import { Link, useRouteMatch } from 'react-router-dom';


const FilesTable: React.FunctionComponent<{ files: SecretFile[], root: string }> = ({ files, root }) => {

    const table_body = (files: SecretFile[]) => {
        return files.map(file => {
            const secret_provider = `${file.secret_provider_key_ref.secret_provider_name}/${file.secret_provider_key_ref.secret_provider_key}`
            const keyvault = `${file.keyvault_key_ref.keyvault_name}/${file.keyvault_key_ref.keyvault_key}`
            const { url } = useRouteMatch<{ url: string }>();
            const encodedFilePath = encodeURIComponent(file.name);

            return (
                <Tr key={file.name}>
                    <Td>
                        <ResourceItem type={ResourceItemType.Secret}>
                            <Link to={`${url}/file/${encodedFilePath}`}>{file.name}</Link>
                        </ResourceItem>
                    </Td>
                    <Td>{keyvault}</Td>
                </Tr>
            );
        })
    }

    return  <Table variant={TableVariant.compact}>
            <Thead>
                <Tr>
                    <Th width={50}>Path</Th>
                    <Th>Keyvault</Th>
                </Tr>
            </Thead>
            <Tbody>{table_body(files)}</Tbody>
        </Table>
    
}

export { FilesTable }